export const moduleTourVideos = [
  {
    name: "Financial Advisor",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/9f79b69c-a300-4d20-a674-b40a13b3a10e.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/1c1ed167-b92f-4dc3-8732-7e5b6ddd5acf.png",
    description: "Have a Tour of the Professional Dashboard",
  },
  {
    name: "Link Bank",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/4bf675d9-e92e-4c78-8afd-d17209c71566.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/5208c017-53c4-407d-bfae-3e4744922fbd.png",
    description: "Have a Tour of the Link Bank Module",
  },
  {
    name: "Tax & Inflation",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/e2652101-3a40-4084-8407-9af15aeb24d0.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/ad215f44-e325-40fe-993a-3a789ece1b03.png",
    description: "Have a Tour of the Tax & Inflation Module",
  },
  {
    name: "Source of Income",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/9b2030b1-3373-4658-8a27-d814f1bd8d2d.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/e90d2b85-4a52-42e4-a7c6-e4a444751276.png",
    description: "Have a Tour of the Source of Income Module",
  },
  {
    name: "Social Security",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/54697bc5-b6dd-4844-91cb-e7f9f7fba96b.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/aa5b6b64-963f-4ea6-8a7c-7d10c92fca6f.png",
    description: "Have a Tour of the Social Security Module",
  },
  {
    name: "Reports",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/1e7fee75-c688-41e5-867d-3d715f684b81.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/89b82a34-ac29-4527-a793-b9d44ffb4f90.png",
    description: "Have a Tour of the Reports Module",
  },
  {
    name: "Rates of Return",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/a6dab1ba-512b-42dd-a82c-255d5c6628a0.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/3040e982-ad80-49b1-92a8-5bdcd1d48327.png",
    description: "Have a Tour of the Rates of Return Module",
  },
  {
    name: "Protector",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/953bb4bb-10ee-43c2-b0d7-57f4204fb2d4.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/f828bd25-3a8b-4498-a72e-de6baa65269f.png",
    description: "Have a Tour of the Protector Module",
  },
  {
    name: "Planner",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/c53b8c78-e3a3-4ad9-9e30-6867d661f482.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/aa579ebd-780e-4023-adc6-5049599759ce.png",
    description: "Have a Tour of the Planner Module",
  },
  {
    name: "Organizer",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/e53e42ef-2236-41e7-a571-07df6021e08a.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/7a97c6fc-be89-4049-b2d1-647bc95c318b.png",
    description: "Have a Tour of the Organizer Module",
  },
  {
    name: "Manage Secure Links",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/9281b82b-c45e-4e08-add0-d358ec5148dd.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/413847c6-bed6-4b9a-83d9-1e95b2c20623.png",
    description: "Have a Tour of the Manage Secure Links Module",
  },
  {
    name: "Liabilities & Credit",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/1dfde380-0078-4a6d-a7c1-f0050c4a0b40.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/47866566-c909-4d95-8c9b-385d51961f74.png",
    description: "Have a Tour of the Liabilities & Credit Module",
  },
  {
    name: "Insurance",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/19f57122-3340-4c84-b1a1-94791b9a7c74.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/6b31d7f9-8bcd-4eab-b105-5da60f09c881.png",
    description: "Have a Tour of the Insurance Module",
  },
  {
    name: "Important Documents",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/0d545025-5f95-46f4-b39f-ef4aa7fe8475.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/13486ac4-d957-41bd-a818-7c7711f5a472.png",
    description: "Have a Tour of the Important Documents Module",
  },
  {
    name: "Client Contacts",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/2ccc6c4d-76d3-45d4-a242-21e1fa3286b5.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/33ad0d08-87f1-46b3-830e-3cb98a36f3b2.png",
    description: "Have a Tour of the Client Contacts Module",
  },
  {
    name: "Goals",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/ee2c624b-912d-45a7-a45f-b756b7bf4881.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/738b6b3d-0da5-4ec3-bd0e-ea9f7c832a25.png",
    description: "Have a Tour of the Goals Module",
  },
  {
    name: "Feedback",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/bcfac58e-fcf8-46f7-b34d-78fa368e12eb.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/292e96d9-f801-4500-8d33-2ec040fc3678.png",
    description: "Have a Tour of the Feedback Module",
  },
  {
    name: "FAQ Help & Support",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/4c7af6b7-908d-4d6d-84b3-17d73de0f941.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/be49e6d3-4171-4d8f-9f2f-f1228657afab.png",
    description: "Have a Tour of the FAQ Help & Support Module",
  },
  {
    name: "Divorce",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/b525b37c-f834-4648-a615-7407dada8e03.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/b5c62aae-f1f6-48f3-9db3-156b875bee57.png",
    description: "Have a Tour of the Divorce Module",
  },
  {
    name: "Disaster",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/e53b1969-9904-4694-b2de-5651f96bc24a.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/ea0acaf1-98aa-43bd-9f2f-c73b7cef0005.png",
    description: "Have a Tour of the Disaster Module",
  },
  {
    name: "Disability",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/be62fd17-808d-4152-b4c7-3c2a9dc3f486.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/58347202-6371-4d8a-95d8-5d6e6e8ef1ca.png",
    description: "Have a Tour of the Disability Module",
  },
  {
    name: "Debt Payoff",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/ba7685d3-5833-49f9-ae8c-e0b21cbaea10.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/05740427-b02f-4172-afd0-ed8faaa8ca3c.png",
    description: "Have a Tour of the Debt Payoff Module",
  },
  {
    name: "Death",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/9d8ea41c-056c-432d-9f9c-c43bb9f3123e.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/42645645-3ac9-4bfc-9270-79f8ea7b8a96.png",
    description: "Have a Tour of the Death Module",
  },
  {
    name: "Dashboard",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/0b8456fc-f9da-462a-afa6-847cba417bed.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/461208fa-e819-401c-aba5-f871eaa1394c.png",
    description: "Have a Tour of the Dashboard",
  },
  {
    name: "Chat",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/79d9dcd0-e0c3-4a42-a8de-2723f68fe94e.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/85dc4b5f-c0d5-4ebd-aa81-7f278958df43.png",
    description: "Have a Tour of the Chat Module",
  },
  {
    name: "Budget",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/4b1375ed-e224-489f-ba49-43dde0149d03.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/a72623d9-a242-481e-8af9-d0ec900daacc.png",
    description: "Have a Tour of the Budget Module",
  },
  {
    name: "Assets",
    videoUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/b222f137-dce0-476c-a281-0df52c6445df.mp4",
    thumbnailUrl:
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/08dea8aa-deb8-4822-a716-7bf28d331b4b.png",
    description: "Have a Tour of the Assets",
  },
];
